import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { NotificationParams } from "./notification.interface";

@Injectable({
    providedIn: "platform",
})
export class NotificationService {
    baseUrl = `${environment.baseUrl}`;

    constructor(private http: HttpClient) {}

    getNotificationList(paramsData: NotificationParams) {
        return this.http.get<any>(`${this.baseUrl}/customer-notification/list`, {
            params: { ...paramsData },
        });
    }

    getNotificationRead(notificationId: string, paramsData: NotificationParams) {
        return this.http.put<any>(`${this.baseUrl}/customer-notification/read/${notificationId}`, {
            paramsData: { ...paramsData },
        });
    }

    getNotificationAllRead() {
        return this.http.put<any>(`${this.baseUrl}/customer-notification/all/read`, {});
    }
}
